import { gql } from '@apollo/client';

export const GET_MANAGER = gql`
  query Mitarbeiter_GetManagerByStandortId($standortId: String!) {
    mitarbeiter_getAllManagerByStandortId(standortId: $standortId) {
      id
      vorname
      nachname
      ausgeblendeteArbeitsbereichIds
    }
  }
`;
